import papa from 'papaparse'

import downloadCSV from '_lib/downloadCSV.js'

import { formatChangeValue } from './operations'

const formatChanges = (changes = {}) =>
  Object.entries(changes)
    .map(
      ([field, { from, to }]) => `${field}: ${formatChangeValue(from)} -> ${formatChangeValue(to)}`
    )
    .join(' | ')

export function downloadSessionReport(session) {
  const metadata = papa.unparse({
    fields: [
      'session_id',
      'collection',
      'created_at',
      'finished_at',
      'status',
      'query',
      'total_audiences',
    ],
    data: [
      [
        session.id,
        session.collection,
        session.created_at,
        session.updated_at,
        session.status,
        JSON.stringify(session.query),
        session.ids.length,
      ],
    ],
  })

  const results = papa.unparse({
    fields: [
      'audience_id',
      'audience_name',
      'result',
      'attempts',
      'last_error',
      'error_history',
      'changes',
    ],
    data: Object.entries(session.results).map(([id, result]) => ({
      audience_id: id,
      audience_name: result.name,
      result: result.status,
      attempts: result.attempts || 0,
      last_error: result.errors?.[result.errors.length - 1]?.message || '',
      error_history: (result.errors || [])
        .map(({ at, message }) => `${at}: ${message}`)
        .join(' | '),
      changes: formatChanges(result.changes),
    })),
  })

  const date = session.created_at.split('T')[0]
  downloadCSV(`${metadata}\n\n${results}`, `bulk-edit-report-${date}-${session.id.slice(-6)}`)
}
